import { defaultHttpClient } from 'shared/src/api/httpClient';
import type { RemoveFavoriteMarketParams } from './types';
import type { ResponseFavoriteMarket } from '../types';

/**
 * - 마켓 Favorite 제거
 */
export const removeFavoriteMarket = ({ sno }: RemoveFavoriteMarketParams) => {
  return defaultHttpClient.request<ResponseFavoriteMarket>({
    method: 'DELETE',
    url: `/api/v2/markets/${sno}/favorite`,
  });
};
